import React from "react";
import { Typography } from "@mui/material";

/**
 * Subject sits in a DataGrid cell whose type is 13px (theme MuiDataGrid).
 * A plain Typography is body1 (16px) and wins over that, so the Subject
 * column looked larger than the columns beside it (Bug 81630).
 */
const MessageSubjectText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="inherit" sx={{ ml: 1 }}>
    {children}
  </Typography>
);

export default MessageSubjectText;
